import { Navigate, Outlet } from 'react-router-dom';
import useAuthState from '../../hooks/internal/auth/useAuthState.js';
import ChartsSkeleton from '../skeletons/ChartsSkeleton.js';

/*
 ** AuthGuard - top level dashboard feature node boundary **
 * Note 1: Single State Update across 'isLoading' and 'isAuthenticated' properties used by object provided in slot in context
        Initial State       -> isLoading: true,  isAuthenticated: false  (Auth vendor SDK re-running after re-direct back to app)
        Pass First Gate and Second Gate on Success: Single State Update -> isLoading: false, isAuthenticated: true   (Both updated simultaneously after run complete)
        Pass First Gate not Second Gate Fail:       Single State Update -> isLoading: false, isAuthenticated: false  (Both updated simultaneously after run complete)
 * Note 2: When isAuthenticated === true, the `user` object from Auth0 context is guaranteed to be available. Any downstream component can safely call
        Auth0 vendors library only sets 'isAuthenticated' to true if / after the user object is fully hydrated / session validated
 */

const AuthGuard = () => {
    const { isAuthenticated, isLoading, user } = useAuthState();

    console.log("[isLoading]:", isLoading)
    console.log("[isAuthenticated]:", isAuthenticated)
    console.log("[USER]:", user)
    
    //debugger;    // uncomment out to pause here to see above logs if getting immediately re-directed back to "/" when not as expected
    
    if (isLoading) {
        return <ChartsSkeleton />;
    }

    if (!isLoading && !isAuthenticated) {
        return <Navigate to="/" replace />;
    }
    
    return <Outlet />
};

export default AuthGuard;
